import React from 'react';
import { Star as LucideStar, LucideProps } from 'lucide-react';

export const StarFill = (props: LucideProps) => (
  <LucideStar
    fill="currentColor"
    {...props}
  />
);

export default StarFill;
